import { render, staticRenderFns } from "./appointOrderList.vue?vue&type=template&id=778adb64&scoped=true"
import script from "./appointOrderList.vue?vue&type=script&lang=ts"
export * from "./appointOrderList.vue?vue&type=script&lang=ts"
import style0 from "./appointOrderList.vue?vue&type=style&index=0&id=778adb64&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778adb64",
  null
  
)

export default component.exports